import * as types from "../actions/ActionTypes";
import { produce } from "immer";

const reviewAmountFilter = {
  args: ["2"],
  sign: ">",
  filterType: {
    data: "review_amount",
    item: "# of reviews",
    text: "# of reviews",
    type: "number",
  },
};
const onlyAvailableShoesFilter = {
  args: ["1"],
  sign: ">",
  filterType: {
    data: "colorway_amount",
    item: "# of available colorways",
    text: "# of available colorways",
    type: "number",
  },
};

function getQuizData(brand) {
  return [
    {
      question: "What type of player are you?",
      description: "Different playing styles call for different shoes.",
      selections: [
        {
          text: "Quick and shifty guard",
          filter: "guard",
        },
        {
          text: "Versatile wing or forward",
          filter: "forward",
        },
        {
          text: "Big and powerful center",
          filter: "center",
        },
      ],
      filter: {
        item: "position",
        data: "position",
        text: "position",
        type: "position",
      },

      images: [0, 0, 0],
      checkstatus: [false, false, false],
      multiple: false,
      result: false,
      multipleColumns: false,
    },
    {
      question: "What type of basketball shoes do you like?",
      description: {
        guard:
          "Most guards prefer the flexibility and freedom of movement of Low- or Mid Top shoes.",
        forward:
          "Pick Low- or Mid-Top shoes for flexibility or High Tops for more stability.",
        center:
          "Most Centers prefer the support and stability of High-Top shoes.",
      },
      selections: [
        {
          text: "Low Top",
          filter: "Low Top",
        },
        {
          text: "Mid Top",
          filter: "Mid Top",
        },
        {
          text: "High Top",
          filter: "High Top",
        },
      ],
      filter: {
        item: "Style",
        data: "style",
        text: "Style",
        type: "list",
      },

      images: [
        __cdn__ + "/IMG/nike-mamba-instinct-852473-010_585x585.png",
        __cdn__ + "/IMG/nike-kobe-ad-mid-922482-009_585x585.png",
        __cdn__ + "/IMG/nike-lebron-soldier-13-ar4225-004_585x585.png",
      ],
      checkstatus: [true, true, true],
      multiple: true,
      result: false,
      multipleColumns: false,
    },
    {
      question: "How wide are your feet?",
      description: "This will make sure that the shoes fit your feet.",
      selections: [
        {
          text: "Narrow",
          filter: "narrow",
        },
        {
          text: "Regular",
          filter: "regular",
        },
        {
          text: "Wide",
          filter: "wide",
        },
      ],
      filter: {
        item: "Width",
        data: "width_text",
        text: "Width",
        type: "list",
      },

      images: [0, 0, 0],
      checkstatus: [false, false, false],
      multiple: false,
      result: false,
      multipleColumns: false,
    },
    {
      question: "Do you play outdoors a lot?",
      description:
        "The rubber and upper material of outdoor shoes needs to be more durable.",

      selections: [
        {
          text: "No, very little.",
          filter: "no",
        },
        {
          text: "All the time",
          filter: "yes",
        },
      ],
      filter: {
        item: "Outdoor Use",
        data: "outdoor_text",
        text: "Outdoor Use",
        type: "list",
      },
      images: [0, 0, 0],
      checkstatus: [false, false],
      multiple: false,
      result: false,
      multipleColumns: false,
    },
    {
      question: "What shoe brands do you like?",
      description: "Select all shoe brands you like to play in.",
      filter: {
        item: "Brands",
        data: "brand",
        text: "Brands",
        type: "list",
      },
      selections: brand,
      images: brand.map(() => {
        return 0;
      }),
      checkstatus: brand.map(() => {
        return false;
      }),
      multiple: true,
      result: false,
      multipleColumns: true,
    },
    {
      question: "How much are you willing to spend?",
      description:
        "Some shoes cost up to $200, but there are also great budget sneakers under $100.",
      selections: "number",
      filter: {
        item: "Best Price",
        text: "Best Price",
        data: "discount",
        type: "number",
      },

      images: [0],
      checkstatus: [],
      multiple: false,
      value: 150,
      result: false,
      multipleColumns: false,
    },
    {
      result: true,
    },
  ];
}

const initialState = {
  reviewAmountFilter,
  onlyAvailableShoesFilter,
  loading: false,
  numberInput: [],
  checkstatus: [],
  all_shoe_count: 0,
  current_shoe_count: 0,
  quizPages: [],
  filterObject: [],
  quiz_output_data: [],
  initiated: false,
};

export default function quiz(state = initialState, action = {}) {
  switch (action.type) {
    case types.INITIATE_QUESTIONS: {
      let { brands, all_shoe_count } = action.value;
      let quiz_brands = brands
        .filter((x) => x.count > 0)
        .map((x) => ({ text: x.option, filter: x.option }));
      let quizPages = getQuizData(quiz_brands);
      return {
        ...state,
        initiated: true,
        all_shoe_count: all_shoe_count,
        current_shoe_count: all_shoe_count,
        quizPages: getQuizData(quiz_brands),
        checkstatus: quizPages.map((page) => page.checkstatus),
        numberInput: quizPages.map((page) => page.value),
      };
    }

    case types.CHANGE_ANSWER:
      return {
        ...state,
        checkstatus: action.value.checkstatus,
        numberInput: action.value.numberInput || state.numberInput,
      };

    case types.NEW_COUNT:
      return {
        ...state,
        current_shoe_count: action.value,
      };

    case types.QUIZ_OUTPUTDATA:
      return {
        ...state,
        quiz_output_data: action.value,
      };

    case types.QUIZ_FILTER:
      let newFilterObject = produce(state.filterObject, (draft) => {
        draft[action.value.question_nr] = action.value.filters;
      });
      return {
        ...state,
        filterObject: newFilterObject,
      };

    default:
      return state;
  }
}
